import * as React from 'react'
import ErrorIllustration from 'assets/icons/not-found.svg'
import styles from './index.module.css'

type Props = {
  title?: React.ReactNode
  subtitle?: React.ReactNode
  body?: React.ReactNode
}

export default function ErrorPage({
  title = 'Oops! Something went wrong',
  subtitle,
  body = (
    <span>
      DISCO has encountered an internal error and the team have been notified.
    </span>
  ),
}: Props): React.ReactElement {
  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <ErrorIllustration className={styles.illustration} />
        <div className={styles.textBlock}>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          <p className={styles.body}>{body}</p>
        </div>
      </div>
    </div>
  )
}
